import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { searchStationAPI, searchOnlineStationsAPI } from "../api/stations";

// Pretraga stanica za Autocomplete: debounce 300ms + otkazivanje prethodnog
// zahteva dok korisnik kuca. Ispod 2 karaktera ne šalje zahtev.
// Jedna instanca hooka = jedno polje (pozvati dvaput za polaznu i dolaznu).
export default function useStationSearch(fromStationId = null) {
    const [stations, setStations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState("");
    const cancelRef = useRef(null);

    useEffect(() => {
        if (!input || input.length < 2) {
            setStations([]);
            return undefined;
        }
        const timer = setTimeout(async () => {
            if (cancelRef.current) cancelRef.current.cancel("Nova pretraga");
            cancelRef.current = axios.CancelToken.source();
            const token = cancelRef.current.token;
            setLoading(true);
            try {
                const list = await searchOnlineStationsAPI({ name: input, fromStationId }, token);
                setStations(Array.isArray(list) ? list : []);
            } catch (onlineError) {
                if (axios.isCancel(onlineError)) return;
                console.error("Pretraga online stanica nije dostupna, pada se na staru pretragu:", onlineError);
                try {
                    const data = await searchStationAPI({ name: input }, token);
                    if (data?.content) setStations(data.content);
                    else if (Array.isArray(data)) setStations(data);
                    else setStations([]);
                } catch (error) {
                    if (!axios.isCancel(error)) console.error("Greška pri učitavanju stanica:", error);
                }
            } finally {
                setLoading(false);
            }
        }, 300);
        return () => clearTimeout(timer);
    }, [input, fromStationId]);

    return { stations, loading, input, setInput };
}
